import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { InspectionTask } from '../types/InspectionTask';

export const listInspectionTasks = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<InspectionTask>> =>
  apiFetch('/inspection-tasks?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
export const listInspectionTasksAll = (): Promise<InspectionTask[]> => apiFetch('/inspection-tasks/all');
export const getInspectionTask = (id: number): Promise<InspectionTask> => apiFetch('/inspection-tasks/' + id);
export const createInspectionTask = (data: any): Promise<InspectionTask> =>
  apiFetch('/inspection-tasks', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const createExtraInspectionTask = (data: {
  proposalId: number;
  accountId: number;
  attributeId: number;
  qty: number;
}): Promise<InspectionTask> =>
  apiFetch('/inspection-tasks/extra', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateInspectionTask = (id: number, data: any): Promise<InspectionTask> =>
  apiFetch('/inspection-tasks/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteInspectionTask = (id: number): Promise<void> =>
  apiFetch('/inspection-tasks/' + id, { method: 'DELETE' });
